import * as envVariables from './env';

export const GlobalConstantMixin = {
    data() {
        return {
            env: envVariables
        };
    }
};